import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'
import { FILE_UPLOAD_FRAGMENT } from '@base/api/fragments/fileUpload'

export const FETCH_PROFILE_PICTURE_UPLOAD_QUERY = gql`
  ${FILE_UPLOAD_FRAGMENT}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}
  query fetchProfilePictureUpload($fileExtension: FileExtension!) {
    fetchProfilePictureUpload(fileExtension: $fileExtension) {
      ...FileUpload
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
